import React from 'react';

function Soutiens() {
  function importAll(r) {
    return r.keys().map(fileName => ({
      fileName,
      fileContent: r(fileName)
    }));
  }
  const images = importAll(require.context(process.env.PUBLIC_URL + '/public/images/soutiens/', false, /\.(png|jpe?g|svg)$/));

  return (
    <section id="soutiens" style={{padding: "0 10px 5px 10px"}}>
      {/* <h2 className="text-center">Merci à nos partenaires</h2> */}
      <div className="gallery">
        {images.map((image, index) => {
          return <img key={index} src={image.fileContent} alt="" className='fondateur allways-keep' />;
        })}
      </div>
    </section>
  )
}

export default Soutiens;
